export default "__VITE_ASSET__CKqSeHLB__"